import React, { useState } from 'react';

import { Transfer } from 'antd';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { COLORS } from '../../../utils/theme/colors';


const TagsTransfer = ({ dataSource, targetKeys, setTargetKeys }) => {

  const [selectedKeys, setSelectedKeys] = useState([]);

  const onChange = (nextTargetKeys, direction, moveKeys) => {
    setTargetKeys(nextTargetKeys);
  };

  const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };

  return (
    <OperationsTransferWrapper>
      <Transfer
        dataSource={dataSource}
        titles={[T('Available'), T('Selected')]}
        targetKeys={targetKeys}
        selectedKeys={selectedKeys}
        onChange={onChange}
        onSelectChange={onSelectChange}
        render={item => item.title}
        listStyle={{
          width: 250,
          height: 130,
        }}
      />
    </OperationsTransferWrapper>
  );
};

const OperationsTransferWrapper = styled.div`
  margin: 0.5em 1em 0.5em 0;

  .ant-transfer-list-header-selected, .ant-transfer-list-header-title {
    color: ${COLORS.primary};
  }
`;

export default TagsTransfer;
